import Layout from "../../../components/org/Layout";
import { Subdomain } from "../../../utils/subdomain/subdomain";
import { Container } from "@mui/material";
import { InferGetServerSidePropsType } from "next";
import { flow, pipe } from "fp-ts/function";
import { executeSupabaseQuery } from "../../../utils/supabase/useQuery";
import * as t from "io-ts";
import { columns } from "../../../utils/pg-ts/pg-ts";
import { supabase } from "../../../utils/supabase/init";
import { array, either, task, taskEither } from "fp-ts";
import { serializeMdx } from "../../../utils/mdx/serializeMdx";
import { pageTable } from "../../../domain/page";
import { pick, runTask } from "../../../utils/fp";
import { Mdx } from "../../../utils/mdx/Mdx";
import * as React from "react";
import { createClient } from "@supabase/supabase-js";
import { env } from "../../../utils/env/env";

const subdomain = "jesenickysnek" as Subdomain;

export const getServerSideProps = async () =>
    pipe(
        env,
        either.map((validEnv) =>
            createClient(
                validEnv.NEXT_PUBLIC_SUPABASE_URL,
                validEnv.SUPABASE_SERVICE_KEY
            )
        ),
        taskEither.fromEither,
        taskEither.chainW((supabase) =>
            pipe(
                executeSupabaseQuery(
                    "pageContent",
                    pageCodec,
                    (supabase) =>
                        supabase
                            .from(pageTable.name)
                            .select(columns(pageCols))
                            .eq("id", 1) // TODO hardcoded
                            .single(),
                    supabase
                )
            )
        ),
        taskEither.chainW((page) =>
            pipe(
                page.content,
                serializeMdx,
                taskEither.map((mdxContent) => ({
                    mdxContent,
                }))
            )
        ),
        task.map(
            either.foldW(
                (e) => {
                    return {
                        notFound: true as const, // as const have to be here :/
                    };
                },
                (props) => {
                    return {
                        props,
                    };
                }
            )
        ),
        runTask
    );

export default (p: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    return (
        <Layout
            subdomain={subdomain}
            seo={{ title: "Pravidla - Jesenický šnek" }}
        >
            <Container maxWidth={"md"}>
                <Mdx mdxContent={p.mdxContent} />
            </Container>
        </Layout>
    );
};

const pageCols = pipe(pageTable.columns, pick("content"));
const pageCodec = t.type(pageCols, "PageContent");
